import { configUiPanel_mobile_vertical as  configUiPanel_default} from "src/library/minigame_client/ui/panel"

export let configUiPanel_mobile_vertical = _.cloneDeep(configUiPanel_default);

configUiPanel_mobile_vertical.sndBtnClick = "res/sounds/btn_click";
configUiPanel_mobile_vertical.sndBtnPlay = "res/sounds/btn_click";
configUiPanel_mobile_vertical.balanceTabPosition = {x: 154, y: 4};
configUiPanel_mobile_vertical.buttonPlaceBetText = 'PLACE A BET';
configUiPanel_mobile_vertical.buttonPlaceBetTextScale = {x: 0.8, y: 1.0};


//////////////////
// WEBPACK FOOTER
// ./cfg/mobile_vertical/panel.es6
// module id = 47
// module chunks = 0